import AccordionBlock from './accordionBlock.component';

export default AccordionBlock;
